import type { IslandRenderer } from "./mount";
import type { LaboDraw } from "../components/labo/laboStats";
import { TopNumerosPeriodeTool } from "../components/labo/TopNumerosPeriodeTool";
import { TauxTheoriqueTool } from "../components/labo/TauxTheoriqueTool";
import { SignatureDurableTool } from "../components/labo/SignatureDurableTool";

const draws = (props: unknown): LaboDraw[] => {
  const tirages = (props as { tirages?: unknown })?.tirages;
  return Array.isArray(tirages) ? (tirages as LaboDraw[]) : [];
};

/** Famille « outils » ouverte : les tirages servis sont l'exemple figé (premiers tirages de la formule). */
const exemple = (props: unknown): boolean => (props as { exemple?: unknown })?.exemple === true;

/** Clés = valeur de data-island dans templates/pages/labo/*.html.twig. Visiteurs anonymes : 50 tirages, aperçu de la signature. */
export const LABO_ISLANDS: Record<string, IslandRenderer> = {
  "top-numeros-periode": (props) => <TopNumerosPeriodeTool tiragesDesc={draws(props)} exemple={exemple(props)} />,
  "taux-sortie": (props) => <TauxTheoriqueTool tiragesDesc={draws(props)} exemple={exemple(props)} />,
  signature: (props) => <SignatureDurableTool tiragesDesc={draws(props)} isPremium={false} />,
};
